import { StyledText } from "../common/styled-text"

export function HeaderText() {
  return (
    <>
      <StyledText className="text-base-black">Crash the</StyledText>
      <StyledText variant="stroke" className="mb-0 text-base-blue">
        <br />
        Group Chat
      </StyledText>

      <p className="font-regular mt-4 mt-8 font-inter text-[min(6vw,1.25rem)] leading-[1.5] text-base-black opacity-80 md:max-w-[615px] md:text-[min(2.8vw,1.85rem)]">
        Epic group chats hosted by your favorite podcasters, politicos, reality stars, athletes,
        comedians & more
      </p>
    </>
  )
}
